import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule  } from '@angular/forms';
import { DocumentEditorComponent } from 'src/app/components/document-editor/document-editor.component';
import { ApiService } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-pdf-example',
  standalone: false,
  templateUrl: './pdf-example.component.html',
  styleUrls: ['./pdf-example.component.scss']
})

export class PdfExampleComponent implements OnInit  {
  pdfForm: FormGroup;
  uuid: string;

  constructor(private apiHelper: ApiService, private formBuilder: FormBuilder ) {

  }

  ngOnInit() {
    this.pdfForm  =  this.formBuilder.group({
      pdfUuid: ['', Validators.required]
    });
  }

  changePDF() {
    this.uuid = this.pdfForm.value['pdfUuid'];
  }
}
